import {isDevEnvironment, isTestEnvironment} from 'appShell/Layout/Navigation';
import {useUserContext} from 'authentication/UserContext';
import React from 'react';

const useQuestionsPermissions = () => {
	const {isReader, isRegulationReader} = useUserContext();
	const shouldShowFaq = React.useMemo(() => {
		const should =
			(isDevEnvironment() || isTestEnvironment()) &&
			!isReader &&
			!isRegulationReader;
		return should;
	}, [isReader, isRegulationReader]);

	return {shouldShowFaq};
};

export default useQuestionsPermissions;
